var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatchTripCreation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.2 21",
    style: {
      enableBackground: "new 0 0 21.2 21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.8,6.5h9.2V4.7H4.8V6.5z M9.1,17.6H2.9c-0.5,0-0.9-0.2-1.3-0.5c-0.4-0.4-0.5-0.8-0.5-1.3V2.9 c0-0.5,0.2-0.9,0.5-1.3S2.4,1,2.9,1h12.8c0.5,0,0.9,0.2,1.3,0.5s0.5,0.8,0.5,1.3V9c-0.4-0.2-0.9-0.4-1.3-0.5 c-0.5-0.1-0.9-0.2-1.4-0.2c-0.2,0-0.3,0-0.5,0c-0.1,0-0.3,0-0.4,0.1V8.4H4.8v1.8h5.6c-0.3,0.3-0.5,0.5-0.7,0.8 c-0.2,0.3-0.4,0.6-0.6,1H4.8v1.8h3.7c0,0.2,0,0.3-0.1,0.4c0,0.1,0,0.3,0,0.5c0,0.5,0,1,0.1,1.4C8.7,16.6,8.8,17.1,9.1,17.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.1,19.7c0.9-2,1.7-3.9,1.7-5c0-2.8-2.3-5.1-5.1-5.1c-2.8,0-5.1,2.3-5.1,5.1c0,1.1,0.8,3.1,1.7,5H18.1z  M14.8,11.9c1.4,0,2.5,1.1,2.5,2.5c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5S13.4,11.9,14.8,11.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchTripCreation);
export default __webpack_public_path__ + "static/media/batch-trip-creation.7ba6c9165b1b74f9232e3945de66cf25.svg";
export { ForwardRef as ReactComponent };